/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

export type ImageKind = typeof ImageKind[keyof typeof ImageKind];


export const ImageKind = {
  covers: 'covers',
  avatars: 'avatars',
  categories: 'categories',
  collection_covers: 'collection_covers',
  collection_banners: 'collection_banners',
  banners: 'banners',
  emotion_icons: 'emotion_icons',
  emotion_images: 'emotion_images',
} as const;
